/* Email-capture popup. Triggers on 30% scroll OR 25s timer.
   Submits to the Resend worker (/subscribe) with Shopify /contact as backup.
   Persists state in localStorage to avoid re-prompting.
   Respects Shopify.customerPrivacy.marketingAllowed if available. */

(function () {
  'use strict';

  var STORAGE_KEY = 'htc_email_popup_v1';
  var DISMISS_DAYS = 7;
  var SCROLL_THRESHOLD = 0.30;
  var TIMER_MS = 25000;
  var DISCOUNT_CODE = 'WELCOME10';
  var WORKER_URL = 'https://herbterra-restock-email.herbterra.workers.dev';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  var popup, form, emailInput, submitBtn, errorEl, formState, successState, copyBtn;
  var triggered = false;
  var timerId = null;

  function getStatus() {
    try { return localStorage.getItem(STORAGE_KEY) || ''; } catch (e) { return ''; }
  }
  function setStatus(v) {
    try { localStorage.setItem(STORAGE_KEY, v); } catch (e) {}
  }

  function shouldShow() {
    if (window.Shopify && window.Shopify.designMode) return false;
    var pathname = (location.pathname || '').toLowerCase();
    if (/\/(checkout|cart|account|orders|password|search)/.test(pathname)) return false;
    if (pathname.indexOf('/pages/contact') === 0) return false;
    var s = getStatus();
    if (!s) return true;
    if (s === 'submitted') return false;
    if (s.indexOf('dismissed:') === 0) {
      var ts = parseInt(s.split(':')[1], 10) || 0;
      if (Date.now() - ts < DISMISS_DAYS * 86400000) return false;
    }
    return true;
  }

  function consentAllowed() {
    try {
      if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.marketingAllowed === 'function') {
        return window.Shopify.customerPrivacy.marketingAllowed() === true;
      }
    } catch (e) {}
    return true;
  }

  function show() {
    if (!popup) return;
    popup.hidden = false;
    popup.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { popup.classList.add('htc-popup--open'); });
    });
    setTimeout(function () { if (emailInput) emailInput.focus({ preventScroll: true }); }, 360);
  }

  function hide() {
    if (!popup) return;
    popup.classList.remove('htc-popup--open');
    document.body.style.overflow = '';
    setTimeout(function () {
      popup.hidden = true;
      popup.setAttribute('aria-hidden', 'true');
    }, 320);
  }

  function dismiss() {
    setStatus('dismissed:' + Date.now());
    hide();
  }

  function trigger() {
    if (triggered) return;
    if (!shouldShow()) return;
    if (!consentAllowed()) return;
    triggered = true;
    if (timerId) { clearTimeout(timerId); timerId = null; }
    show();
  }

  function setError(msg) {
    if (!errorEl) return;
    errorEl.textContent = msg || '';
    if (emailInput) {
      if (msg) emailInput.classList.add('htc-popup__input--error');
      else emailInput.classList.remove('htc-popup__input--error');
    }
  }

  function setSubmitting(submitting) {
    if (!submitBtn) return;
    submitBtn.disabled = submitting;
    var label = submitBtn.querySelector('[data-htc-popup-submit-label]');
    if (label) label.textContent = submitting ? 'Sending...' : 'Send my code';
  }

  function showSuccess() {
    if (formState) formState.hidden = true;
    if (successState) successState.hidden = false;
  }

  function postToWorkerSubscribe(email) {
    try {
      return fetch(WORKER_URL + '/subscribe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email, source: 'popup' }),
        keepalive: true,
      }).catch(function () { /* silent: Shopify /contact is the capture fallback */ });
    } catch (e) { return Promise.resolve(); }
  }

  function postToShopifyContact(email) {
    var fd = new FormData();
    fd.append('form_type', 'customer');
    fd.append('utf8', '✓');
    fd.append('contact[email]', email);
    fd.append('contact[tags]', 'newsletter,popup-welcome10');
    return fetch('/contact#contact_form', {
      method: 'POST',
      body: fd,
      credentials: 'include',
      keepalive: true,
    }).catch(function () { /* silent: worker /subscribe is the primary path */ });
  }

  function submit(email) {
    setSubmitting(true);
    // Worker sends the welcome email + sets marketing consent; Shopify /contact
    // is the belt-and-braces capture so no signup is ever lost.
    postToWorkerSubscribe(email);
    postToShopifyContact(email).finally(function () {
      setStatus('submitted');
      setSubmitting(false);
      showSuccess();
    });
  }

  function onSubmit(e) {
    e.preventDefault();
    setError('');
    if (!emailInput) return;
    var email = (emailInput.value || '').trim().toLowerCase();
    if (!email) { setError('Enter your email to claim your code.'); emailInput.focus(); return; }
    if (!EMAIL_RE.test(email)) { setError('That doesn\'t look like a valid email.'); emailInput.focus(); return; }
    submit(email);
  }

  function onCopy() {
    if (!navigator.clipboard) return;
    navigator.clipboard.writeText(DISCOUNT_CODE).then(function () {
      var label = copyBtn.querySelector('[data-htc-popup-copy-label]');
      if (label) label.textContent = 'Copied';
      copyBtn.classList.add('htc-popup__copy--copied');
      setTimeout(function () {
        if (label) label.textContent = 'Copy';
        copyBtn.classList.remove('htc-popup__copy--copied');
      }, 2000);
    }).catch(function () {});
  }

  function onScroll() {
    var doc = document.documentElement;
    var top = doc.scrollTop || document.body.scrollTop;
    var max = (doc.scrollHeight || 0) - (doc.clientHeight || 0);
    if (max <= 0) return;
    var pct = top / max;
    if (pct >= SCROLL_THRESHOLD) {
      window.removeEventListener('scroll', onScroll);
      trigger();
    }
  }

  function onKeydown(e) {
    if (e.key === 'Escape' && popup && !popup.hidden) {
      dismiss();
    }
  }

  function init() {
    popup = document.getElementById('htc-popup');
    if (!popup) return;
    if (!shouldShow()) return;

    formState = popup.querySelector('[data-htc-popup-form-state]');
    successState = popup.querySelector('[data-htc-popup-success-state]');
    form = popup.querySelector('#htc-popup-form');
    emailInput = popup.querySelector('#htc-popup-email');
    submitBtn = popup.querySelector('[data-htc-popup-submit]');
    errorEl = popup.querySelector('[data-htc-popup-error]');
    copyBtn = popup.querySelector('[data-htc-popup-copy]');

    if (form) form.addEventListener('submit', onSubmit);
    if (copyBtn) copyBtn.addEventListener('click', onCopy);

    Array.prototype.forEach.call(
      popup.querySelectorAll('[data-htc-popup-close]'),
      function (el) { el.addEventListener('click', dismiss); }
    );
    document.addEventListener('keydown', onKeydown);

    timerId = setTimeout(trigger, TIMER_MS);
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
